import { createInertiaApp } from "@inertiajs/react"
import { createRoot } from "react-dom/client"
import "@fontsource/inter/400.css"
import "@fontsource/inter/500.css"
import "@fontsource/inter/700.css"
import AppLayout from "../layouts/AppLayout"

void createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob("../pages/**/*.tsx", { eager: true })
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      throw new Error(`Inertia page not found: ${name}`)
    }
    return page as { default: React.ComponentType }
  },
  setup({ el, App, props }) {
    createRoot(el).render(
      <AppLayout>
        <App {...props} />
      </AppLayout>
    )
  },
  progress: { color: "#1976d2" },
})
